<template>
<v-container grid-list-xl fluid pa-0 ma-0 style="width: 100% !important;">
    <v-layout row wrap>
        <v-flex lg12 pt-1>
            <v-app-bar flat color="white">                
                <v-text-field flat solo prepend-icon="fa-search" :placeholder="placeholderText ? placeholderText : 'Tìm kiếm'" v-model="quickSearchTerm" hide-details v-on:keyup.enter="quickSearchData"></v-text-field>
                <template v-for="(cond, index) in conditions">
                    <v-menu v-model="cond.menu" :key="index" :close-on-content-click="false" :nudge-width="200" offset-x v-if="refreshFilter">
                        <template v-slot:activator="{ on }">
                            <v-chip close class="ml-1" v-on="on" @click:close="removeFilter(cond)">{{conditionDisplay(cond)}}</v-chip>
                        </template>
                        <v-card>
                            <v-widget :title="cond.name">
                                <div class="filter-condition-fields" slot="widget-content">
                                    <v-select v-model="cond.selectedCondition" :items="cond.conditions" item-value="value" item-text="name"></v-select>
                                    <v-text-field v-model="cond.value" v-if="cond.dataType === dataTypes.String" @focus="true" @keyup.enter="advanceFilterData(cond)"></v-text-field>
                                    <v-text-field type="number" v-model="cond.value" v-if="cond.dataType === dataTypes.Number" :step="cond.decimal" @focus="true" @change="advanceFilterData(cond)"></v-text-field>
                                    <v-autocomplete :chips="true" :multiple="true" :small-chips="true" :items="cond.listOfValue" v-model="cond.value" item-text="name" item-value="value" @focus="true" v-if="cond.dataType === dataTypes.Enum"></v-autocomplete>
                                    <datepicker v-model="cond.value" input-class="date-value" v-if="cond.dataType === dataTypes.Date" format="dd/MM/yyyy" @focus="true"></datepicker>
                                    <v-flex class="align-end">
                                        <v-btn @click="advanceFilterData(cond)">OK</v-btn>
                                        <v-btn @click="closePopup(cond)" class="ml-1">Hủy</v-btn>
                                    </v-flex>
                                </div>
                            </v-widget>
                        </v-card>
                    </v-menu>
                </template>
                <v-menu :close-on-content-click="false" v-model="filterMenu" nudge-width="200" nudge-left="150" offset-y offset-x v-if="advanceFilterable">
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                            <v-icon>fa-filter</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <template v-for="(item, index) in headers">
                            <v-list-item :key="'col-'+index" v-if="item.filterable" @click="enterCondition(item.value)">
                                <v-list-item-title>{{ item.text }}</v-list-item-title>
                            </v-list-item>
                        </template>
                    </v-list>
                </v-menu>
            </v-app-bar>
            <v-divider class="ma-0"></v-divider>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import { DATA } from '@/config/data';
import _ from "lodash";
import moment from "moment";
import VWidget from "./VWidget.vue";
import { mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
import formatNumber from '@/shared/filters/format-number';
import formatDate from '@/shared/filters/format-date';

export default {
    name: "filtering",
    filters: {},
    components: {
        VWidget,
        Datepicker
    },
    props: {
        headers: Array,
        viewName: String,
        orderbutton: Boolean,
        orderSummary: Object,
        listStatus: Array,
        bindFilter: Array,
        placeholderText: String
    },
    data() {
        return {
            show: true,
            selectedStatus: -1,
            filterMenu: false,
            saveFilterMenu: false,
            selectedConditionValue: "",
            selected: [],
            comparions: DATA.LIST_COMPARISON,
            dataTypes: DATA.DATA_TYPE,
            quickSearchTerm: "",
            savedFilterName: "",
            refreshFilter: true
        };
    },
    computed: {
        selectedCondition() {
            let conditions = [];
            let column = _.find(this.headers, {
                value: this.selectedConditionValue
            });
            if (column) {
                conditions = _.filter(this.comparions, {
                    dataType: column.dataType
                });
            }
            return conditions;
        },
        conditions: {
            get() {
                let filters = this.$store.state.commonStore.filters;
                return !_.isEmpty(filters) && !_.isEmpty(filters[this.viewName]) ?
                    filters[this.viewName] : [];
            },
            set(value) {
                let filters = { ...(this.$store.state.commonStore.filters || {}) };
                filters[this.viewName] = value;
                this.$store.commit("commonStore/setFilters", {
                    filter: filters
                });
            }
        },
        filterConditions: {
            get() {
                let filterConditions = this.$store.state.commonStore.filterConditions;
                return !_.isEmpty(filterConditions) ?
                    filterConditions[this.viewName] : [];
            },
            set(value) {
                let filterConditions = { ...(this.$store.state.commonStore.filterConditions || {}) };
                filterConditions[this.viewName] = value;
                this.$store.commit("commonStore/setFilterConditions", {
                    filter: filterConditions
                });
            }
        },
        advanceFilterable() {
            return _.find(this.headers, {'filterable': true}) != null;
        },
        currentPath() {
            return this.$route.path;
        },
        selectedCustomerName() {
            return this.$route.query.u && this.$route.query.u != '' ? this.$route.query.u : null;
        }
    },
    watch: {
        conditions() {
            this.getLastStatus();
        },
        bindFilter() {
            if (this.bindFilter) {
                this.filterConditions = this.bindFilter;
                this.conditions = [];
                _.each(this.bindFilter, f => {
                    let column = _.find(this.headers, {
                        value: f.column
                    });
                    let condition = {};
                    if (column) {
                        _.each(column.values, itm => _.set(itm, 'disabled', false));
                        let condition_filters = _.filter(this.comparions, {
                            dataType: column.dataType
                        });
                        condition = {
                            column: f.column,
                            name: column.text,
                            value: f.value,
                            menu: false,
                            decimal: column.decimal || 0,
                            dataType: column.dataType,
                            listOfValue: column.values,
                            conditions: condition_filters,
                            selectedCondition: condition_filters[0].value
                        };
                        this.conditions = _.concat(this.conditions, condition);
                    }
                });
            }
        }
    },
    mounted() {
        this.conditions = []
        this.filterConditions = []
        this.getLastStatus();
        
        this.filterByQuery();
    },
    
    methods: {
        filterByQuery() {
            if(this.selectedCustomerName && ['/don-hang', '/khieu-nai/don-hang', '/ky-gui'].includes(this.currentPath)) {
                let condition = {};
                let column = null;
                let col_name = '';
                if (this.currentPath == '/don-hang') {
                    col_name = 'CustomerName'
                }
                if (this.currentPath == '/khieu-nai/don-hang' || this.currentPath == '/ky-gui') {
                    col_name = 'Username'
                }
                if(col_name != '') {
                    column = _.find(this.headers, {
                        value: col_name
                    });
                }
                if(column) {
                    let condition_filters = _.filter(this.comparions, {
                        dataType: column.dataType
                    });
                    condition = {
                        column: col_name,
                        name: column.text,
                        value: this.selectedCustomerName,
                        menu: false,
                        decimal: column.decimal || 0,
                        dataType: column.dataType,
                        listOfValue: column.values,
                        conditions: condition_filters,
                        selectedCondition: 's_equal'
                    };
                    this.conditions = _.concat(this.conditions, condition);
                    this.advanceFilterData();
                }
            }
        },
        enterCondition(item) {
            let column = _.find(this.headers, { value: item });
            let condition = {};
            if (column) {
                _.each(column.values, itm => _.set(itm, 'disabled', false));
                let condition_filters = _.filter(this.comparions, { dataType: column.dataType });
                condition = {
                    column: item,
                    name: column.text,
                    value: column.dataType === DATA.DATA_TYPE['Number'] ? 0 : (column.dataType === DATA.DATA_TYPE['Enum'] ? [] : ""),
                    menu: false,
                    decimal: column.decimal || 0,
                    dataType: column.dataType,
                    listOfValue: column.values,
                    conditions: condition_filters,
                    selectedCondition: condition_filters[0].value
                };
                this.conditions = _.concat(this.conditions, condition);
            }
            this.selected = [];
            this.filterMenu = false;
            this.$nextTick(() => {
                setTimeout(() => {
                    const target = _.find(this.conditions, { column: item });
                    if (target) {
                        this.$set(target, 'menu', true);
                    } else {
                        this.$set(condition, 'menu', true);
                    }
                }, 100);
            });
        },
        conditionDisplay(cond) {
            const condition = _.find(this.comparions, {
                value: cond.selectedCondition
            });
            let displayValue = "";
            if (cond.value !== null && cond.value !== undefined && cond.value !== "") {
                switch (cond.dataType) {
                    case this.dataTypes.Date:
                        displayValue = formatDate(cond.value, "DD/MM/YYYY");
                        break;
                    case this.dataTypes.Number:
                        displayValue = formatNumber(cond.value, cond.decimal ? '0,0.[000]' : '0,0');
                        break;
                    case this.dataTypes.Enum:
                        let listVals = _.split(cond.value, ",");
                        let displayVals = [];
                        for (let i = 0; i < cond.listOfValue.length; i++) {
                            const element = cond.listOfValue[i];
                            if (listVals.includes(element.value.toString())) {
                                displayVals.push(element.name);
                            }
                        }
                        displayValue = displayVals.join(", ");
                        break;
                    default:
                        displayValue = cond.value;
                        break;
                }
            }
            return (
                cond.name +
                " " +
                (condition ? condition.display.replace("{0}", displayValue) : "")
            );
        },
        removeFilter(condition) {
            _.remove(this.conditions, {
                column: condition.column
            });
            this.advanceFilterData();
            this.refreshFilterChips();
        },
        refreshFilterChips() {
            this.refreshFilter = false;
            setTimeout(() => {
                this.refreshFilter = true;
            }, 100);
        },
        getLastStatus() {
            const status = _.find(this.conditions, {'column': 'Status'});
            if(status && status.value.length > 0) {
                this.selectedStatus = status.value[0]
            }
        },
        quickSearchData() {
            let quickConditions = [];
            if(this.quickSearchTerm != "") {
                for (let i = 0; i < this.headers.length; i++) {
                    const column = this.headers[i];
                    if ((column.dataType === DATA.DATA_TYPE.String && column.quickSearch) || column.value === 'ID') {
                        let searchTerm = this.quickSearchTerm.trim();
                        if (searchTerm.startsWith("MD")) {
                            searchTerm = searchTerm.slice(2);
                        }
                        let condition = {
                            column: column.value,
                            value: searchTerm,
                            condition: "contain"
                        };
                        quickConditions = _.concat(quickConditions, condition);
                    }
                }
            }
            this.$emit("quickFilter", quickConditions);
        },
        advanceFilterData(cond) {
        console.log(cond);
            this.closePopup(cond);
            const filter = _.map(this.conditions, obj => {
                obj.menu = false;
                return {
                    column: obj.column,
                    value: obj.dataType === DATA.DATA_TYPE['Date'] ? moment(obj.value).startOf('d').format('YYYY-MM-DD') : obj.value,
                    condition: obj.selectedCondition
                };
            });
            this.filterConditions = filter;
            this.$emit("applyFilter", filter);
            this.refreshFilterChips();
        },
        closePopup(cond) {
            if (cond) {
                cond.menu = false;
            }
            this.refreshFilterChips();
        }
    }
}
</script>

<style  lang="scss">
.btn {
    display: inline-block;
    margin-bottom: 0;
    font-weight: normal;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
    padding: 10px 12px;
    font-size: 12px;
    line-height: 1.42857143;
    border-radius: 2px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.btn-default {
    color: #000000;
    background-color: #ffffff;
    border-color: #bdc3d1;
    text-decoration: none;
}
.btn-status {
    height: 87px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-left: 3px solid;
}
.btn-sm, .btn-group-sm > .btn {
    padding: 5px 8px;
    font-size: 11px;
    line-height: 1.5;
    border-radius: 2px;
}
.btn-block {
    width: 100%;
}
.btn-default:hover {
    color: #696c74;
    background-color: #ededed;
    border-color: #9fa8bc;
}
.btn-sm, .btn-group-sm > .btn {
    padding: 5px 8px 4px;
}
.btn-order-status {
    border-left: 3px solid;
    margin-bottom: 3px;
    span {
        float: right;
        text-align: right;
        border-left: 1px solid;
        border-color: #bdc3d1;
        width: 15%;
        height: 100%;
    }
}
.btn-m-status {
    border-left: 3px solid;
}
.group-box-mb {
    display: none;
    .group-status {
        width: 100%;
        background: #fff;
        border: 1px solid #d8dce3;
        box-shadow: none;
        .btn-toggle {
            width: 100%;
            color: #696c74;
        }
        .dropdown-menu {
            width: 100%;
        }
    }
}

.active-status {
    color: #ffffff;
    background-color: #3b4354;
    border-color: #3b4354;
    a:hover {
        color: #ffffff;
        background-color: #3b4354;
        border-color: #3b4354;
    }
    a {
        color: #ffffff;
    }
}
.divider {
    margin: 0px 0px;
}
.filter-text-box {
    margin-top: 15px;
    margin-bottom: 0px;
    .form-control {
        border: 0px;
        border-bottom: 1px solid #bdc3d1;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }
}
.filter-condition-fields .vdp-datepicker > div > input  {
    padding: 8px;
    margin-bottom: 0 !important;
}
.filter-condition-fields .vdp-datepicker {
    margin-bottom: 24px;
}
@media (max-width: 992px) {
    .group-box-mb {
        display: block;
    }
    .group-box {
        display: none;
    }
}
/* Đảm bảo menu được căn sang bên phải */
.filter-menu-right {
  min-width: 200px; /* Độ rộng tối thiểu của menu */
}

/* Điều chỉnh vị trí menu */
.v-menu__content {
  /* Căn menu sang bên phải màn hình */
  right: 0 !important;
  left: auto !important;
  margin-top: -55px; /* Khoảng cách từ icon xuống menu */
  overflow: visible !important; /* Loại bỏ overflow ẩn */
  max-height: none !important; /* Bỏ giới hạn chiều cao */
  contain: none !important; /* Đảm bảo nội dung không bị giới hạn trong container */
}
.date-value {
    border: 1px solid #afafaf;
    border-radius: 4px;
    font-size: 14px;
}
/* Tăng z-index cho datepicker để hiển thị trên các phần tử khác */
.v-menu__content .v-picker {
  z-index: 1000 !important; /* Đảm bảo datepicker nổi lên trên */
  position: relative;
}
</style>
